import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaBusAlt, FaTruck, FaUserShield, FaClock, FaTools, } from 'react-icons/fa';
import bags from '../images/bags.jpg';
import forgiens from '../images/forgiens.png'
import haj from '../images/haj.png'
import passengers from '../images/passengers.jpg';
import clock from '../images/clock.png';
import tools from '../images/tools.png';
import fleet from '../images/fleet.jpeg';
import drivers from '../images/drivers.jpeg';

import { motion } from "framer-motion";
import { Loader2, Bus, Briefcase, ShoppingBag, Map, Truck, Users } from "lucide-react";

const services = [
    {
        id: 1,
        //imageUrl: passengers,
        imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=800&auto=format&fit=crop",
        icon: "bus",
        titleKey: "passengerTransport",
        descKey: "passengerTransportDesc",
    },
    {
        id: 2,
        imageUrl: forgiens,
        //imageUrl: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&auto=format&fit=crop",
        icon: "bus",
        titleKey: "vipService",
        descKey: "vipDesc",
    },
    {
        id: 3,
        imageUrl: bags,
        //imageUrl: "https://images.unsplash.com/photo-1553531384-cc64ac80f931?q=80&w=800&auto=format&fit=crop",
        icon: "truck",
        titleKey: "cargoTransport",
        descKey: "cargoTransportDesc",
    },
    {
        id: 4,
        imageUrl: haj,
        //imageUrl: "https://images.unsplash.com/photo-1565552629477-cd044b7f0e7d?q=80&w=800&auto=format&fit=crop",
        icon: "bus",
        titleKey: "hajService",
        descKey: "hajDesc",
    },
    {
        id: 5,
        imageUrl: fleet,//"https://images.unsplash.com/photo-1570125909232-eb263c188f7e?q=80&w=800&auto=format&fit=crop",
        icon: "bus",
        titleKey: "modernFleet",
        descKey: "modernFleetDesc",
    },
    {
        id: 6,
        imageUrl: drivers,//"https://images.unsplash.com/photo-1600320254374-ce2d293c324e?q=80&w=800&auto=format&fit=crop",
        icon: "users",
        titleKey: "experiencedDrivers",
        descKey: "experiencedDriversDesc",
    },
    // {
    //     icon: <FaGlobe className="text-blue-600 text-4xl mb-4" />,
    //     titleKey: "regionalService",
    //     descKey: "regionalServiceDesc",
    // }
];

const OurServices = () => {
    const { t, i18n } = useTranslation();
    const language = i18n.language;
    const isRTL = language === "ar" || language === "he";

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });  
    }, []);

    
    const getIcon = (iconName) => {
        switch (iconName) {
            case 'bus': return <Bus className="w-8 h-8" />;
            case 'briefcase': return <Briefcase className="w-8 h-8" />;
            case 'bag': return <ShoppingBag className="w-8 h-8" />;
            case 'truck': return <Truck className="w-8 h-8" />;
            case 'users': return <Users className="w-8 h-8" />;
            case 'map': return <Map className="w-8 h-8" />;
            default: return <Bus className="w-8 h-8" />;
        }
    };

    return (
        <div className="min-h-screen pt-10 pb-20 bg-slate-50 dark:bg-slate-900" dir={t('dir')}>
            <div className="container px-4 mx-auto">
                {/* Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900 dark:text-white">
                        {t('ourServices')}
                    </h1>
                    <div className="h-1.5 w-24 bg-accent mx-auto rounded-full" />
                    {/* <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                        {language === 'ar'
                            ? "نقدم مجموعة شاملة من خدمات النقل لتلبية جميع احتياجاتكم"
                            : "We offer a comprehensive range of transport services to meet all your needs"}
                    </p> */}
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                    {services.map((service, index) => {
                        const title = t(service.titleKey);
                        const desc = t(service.descKey);

                        return (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, scale: 0.95 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ delay: index * 0.1 }}
                                viewport={{ once: true }}
                                className="bg-white dark:bg-slate-800 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 
                                group flex flex-col md:flex-row h-full"
                            >
                                {/* Image */}
                                <div className="md:w-2/5 h-64 md:h-auto overflow-hidden relative">
                                    <img
                                        src={service.imageUrl}
                                        alt={title}
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent md:bg-none" />
                                </div>

                                {/* Content */}
                                <div className="p-8 md:w-3/5 flex flex-col justify-center">
                                    <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-4">
                                        {getIcon(service.icon)}
                                    </div>
                                    <h3 className="text-2xl font-bold mb-3 text-slate-900 dark:text-white">{title}</h3>
                                    <p className="text-muted-foreground leading-relaxed">{desc}</p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default OurServices;
